import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { requestWithToken, requestWithoutToken } from 'src/config';

@Injectable({
    providedIn: 'root'
})
export class ValidationDashService {

    constructor(private http: HttpClient){}

  private filterData: any = {};

  setFilterData(data: any) {
    this.filterData = data;
  }

  getFilterData() {
    return this.filterData;
  }

    async fetchContestdashboard(payload?: any) {
        // Construct the API endpoint with query parameters
        let endpoint = `/admin/contest/master/contestdashboard`;

        return requestWithToken("POST", endpoint, payload).then((res) => {
            return res?.data;
        }).catch((error) => {
            return error;
        })
    }

    async fetchContestlang(params?: any) {
        // const queryString = params && typeof params === 'object' ? `?${new URLSearchParams(params).toString()}` : '';
        return requestWithToken(
            "POST",
            `/admin/contest/master/contestlang`
        ).then((res) => {
            return res?.data;
        }).catch((error) => {
            return error;
        })
    }

    async fetchContestview(payload: any) {

        let endpoint = `/admin/contest/master/contestview`;

        return requestWithToken("POST", endpoint, payload).then((res) => {
            return res?.data;
        }).catch((error) => {
            return error;
        })
    }

    async fetchLangfilter() {
        return requestWithToken(
            "GET",
            `/admin/contest/langfilter`
        ).then((res) => {
            return res?.data;
        }).catch((error) => {
            return error;
        })
    }

    async fetchStatefilter() {
        return requestWithToken(
            "GET",
            `/admin/contest/statefilter`
        ).then((res) => {
            return res?.data;
        }).catch((error) => {
            return error;
        })
    }

    async fetchValstatus() {
        return requestWithToken(
            "GET",
            `/admin/contest/valstatus`
        ).then((res) => {
            return res?.data;
        }).catch((error) => {
            return error;
        })
    }

    async fetchContestSourcesData() {
        return requestWithoutToken(
            "GET",
            `/masters/meta/contest-sources/en`
        ).then((res) => {
            return res?.data;
        }).catch((error) => {
            return error;
        })
    }

    async fetchContestStatusesData() {
        return requestWithoutToken(
            "GET",
            `/masters/meta/contest-statuses/en`
        ).then((res) => {
            return res?.data;
        }).catch((error) => {
            return error;
        })
    }



    async fetchContestViewDetails(id: any) {

        // Construct the API endpoint with query parameters
        let endpoint = `/admin/contest/getdetails/view/`+id;

        return requestWithToken("GET", endpoint).then((res) => {
            return res?.data;
        }).catch((error) => {
            return error;
        })
    }

    async fetchContestEditDetails(id: any) {

        // Construct the API endpoint with query parameters
        let endpoint = `/admin/contest/getdetails/edit/`+id;

        return requestWithToken("GET", endpoint).then((res) => {
            return res?.data;
        }).catch((error) => {
            return error;
        })
    }

    async contestApprove(payload?: any) {
        // Construct the API endpoint with query parameters
        let endpoint = `/admin/contest/approve`;

        return requestWithToken("POST", endpoint, payload).then((res) => {
            return res?.data;
        }).catch((error) => {
            return error;
        })
    }



    downloadData(url:any): Observable<any> {
        // Replace 'your-server-endpoint' with your actual server endpoint to fetch data
        return this.http.get(url, { responseType: 'blob' });
    }

}
